module.exports = __webpack_public_path__ + "static/img/img_member_equities.829ef60c.png";